var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluePen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.8906 11.3584C47.8323 10.9897 47.2406 7.67719 44.8406 5.25844C42.4302 2.90011 39.1052 2.31677 38.7344 2.25844C38.2406 2.17719 37.7365 2.28136 37.3135 2.54386C37.1656 2.63552 34.9927 3.99594 30.7031 7.62302C32.9094 8.40219 35.7615 9.75427 38.074 12.0168C40.3948 14.2876 41.7823 17.0814 42.5781 19.248C46.1615 15.0605 47.5094 12.9397 47.599 12.7939C47.8656 12.3668 47.9698 11.8564 47.8906 11.3584Z",
    fill: "#7A9FF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9758 10.8813C24.7404 12.898 22.1383 15.348 19.1591 18.3063C6.52786 30.848 3.21536 35.8626 3.07995 36.0688C2.89036 36.3605 2.77578 36.6959 2.7487 37.0418L2.08411 45.523C2.03828 46.1314 2.25703 46.7272 2.68828 47.1584C3.07995 47.5501 3.6112 47.7689 4.16328 47.7689C4.21536 47.7689 4.26953 47.7689 4.3237 47.7626L12.8674 47.1043C13.2112 47.0772 13.5424 46.9668 13.832 46.7814C14.0404 46.648 19.0883 43.3584 31.7174 30.8188C34.7633 27.7938 37.2758 25.1605 39.332 22.9084C39.0175 21.5563 37.9195 17.698 35.1549 14.9959C32.3508 12.2522 28.3174 11.1772 26.9758 10.8813Z",
    fill: "#7A9FF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePen);
export default __webpack_public_path__ + "static/media/blue-pen.03c6a7d7b6529272782ab8dd5aa1b1d7.svg";
export { ForwardRef as ReactComponent };